import { Box, type BoxProps } from '@mantine/core'

import { type CoreProduct } from '@flecto/types'

import { CardProductControls } from '../CardProductControls/CardProductControls'
import { CardProductDescription } from '../CardProductDescription/CardProductDescription'
import { CardProductPhotosGallery } from '../CardProductPhotosGallery/CardProductPhotosGallery'
import { CardStoreDetails } from '../CardStoreDetails/CardStoreDetails'
import styles from './styles.module.css'

export type SectionProductDetailsProps = BoxProps & {
  product?: CoreProduct
  isLoading?: boolean
}

export function SectionProductDetails({
  product,
  isLoading,
  ...props
}: SectionProductDetailsProps) {
  if (!product && !isLoading) {
    return
  }
  return (
    <Box {...props} className={styles.wrapper}>
      <CardProductPhotosGallery
        product={product}
        isLoading={isLoading}
        className={styles.cardPhotos}
      />
      <CardProductDescription
        product={product}
        isLoading={isLoading}
        className={styles.cardDescription}
      />
      <CardProductControls
        product={product}
        isLoading={isLoading}
        className={styles.cardControls}
      />
      <CardStoreDetails className={styles.cardStore} />
    </Box>
  )
}
